import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectSelectedComponent, updateComponent } from '../../../redux/editorSlice';
import { PaddingControl } from '../CommonProperties';

const BinaryLegsProperties = () => {
  const selectedComponent = useSelector(selectSelectedComponent);
  const dispatch = useDispatch();
  
  // 컴포넌트 속성 변경 핸들러
  const handleComponentPropsChange = (property, value) => {
    const existingProps = JSON.parse(JSON.stringify(selectedComponent.componentProps || {}));
    existingProps[property] = value;
    
    dispatch(updateComponent({
      id: selectedComponent.id,
      changes: {
        componentProps: existingProps
      }
    }));
  };

  return (
    <>
      {/* <PaddingControl /> */}
      
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 4v2M12 18v2M6 12H4M20 12h-2M17.7 6.3l-1.4 1.4M6.3 17.7l1.4-1.4M17.7 17.7l-1.4-1.4M6.3 6.3l1.4 1.4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2"/>
          </svg>
          바이너리 레그 설정
        </div>
        
        <div className="property-control">
          <label>제목</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.title || "후원 레그"}
            onChange={(e) => handleComponentPropsChange('title', e.target.value)}
          />
        </div>
      </div>
    </>
  );
};

export default BinaryLegsProperties;
